import React from "react";

interface AnalystDashboardProps {
  data: any;
}

const AnalystDashboard: React.FC<AnalystDashboardProps> = ({ data }) => {
  if (!data) return null;
  // Example: render JSON for now, replace with real dashboard UI
  return (
    <div className="bg-[#0a0c10] border border-white/[0.08] rounded-lg p-6 text-white">
      <h3 className="text-lg font-bold mb-2">Dashboard danych</h3>
      <pre className="text-xs whitespace-pre-wrap text-white/80">
        {JSON.stringify(data, null, 2)}
      </pre>
    </div>
  );
};

export default AnalystDashboard;
